import { AfterViewInit, Component, ElementRef, EventEmitter, Signal, viewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { escape } from 'lodash';
import { ImportedCaeProjectDTO } from '@project/model/vo/imported-cae-project.dto';

@Component({
  standalone: false,
  selector: 'app-save-cae-project',
  templateUrl: './save-cae-project.component.html',
})
export class SaveCaeProjectComponent implements AfterViewInit {
  public existingProjectGroup!: ProjectGroupVO;
  public projectsToSave!: ImportedCaeProjectDTO[];

  public finish = new EventEmitter<SaveCaeButton>();

  private createButtonRef: Signal<ElementRef | undefined> = viewChild(`createButton`);

  public projectGroupName: string = '';
  public projectNamesAndStates: {name: string, status: string}[] = [];

  constructor(private bsModalRef: BsModalRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.projectGroupName = escape(this.existingProjectGroup.groupName);
      const existingProjectNames: string[] = [];
      this.existingProjectGroup.projects.forEach(project => {
        existingProjectNames.push(project.name);
        const saveProjectNames = this.projectsToSave.map(p => p.project.name);
        if (!saveProjectNames.includes(project.name)) {
          this.projectNamesAndStates.push({name: escape(project.name), status: 'caeImportPopup.label.unchanged'});
        }
      });
      this.projectsToSave.forEach(project => {
        this.projectNamesAndStates.push({
          name: escape(project.project.name),
          status: existingProjectNames.includes(project.project.name) ? 'caeImportPopup.label.updated' : 'caeImportPopup.label.new'
        });
      });
      this.createButtonRef()?.nativeElement.focus();
    }, 0);
  }

  ngOnDestroy(): void {
    this.bsModalRef.hide();
    this.finish.emit(SaveCaeButton.CANCEL);
  }

  public cancel(): void {
    this.bsModalRef.hide();
    this.finish.emit(SaveCaeButton.CANCEL);
  }

  public createNew(): void {
    this.bsModalRef.hide();
    this.finish.emit(SaveCaeButton.CREATE_NEW);
  }

  public update(): void {
    this.bsModalRef.hide();
    this.finish.emit(SaveCaeButton.UPDATE_EXISTING);
  }
}

export enum SaveCaeButton {
  CANCEL,
  CREATE_NEW,
  UPDATE_EXISTING,
  NO_ACTION,
}
